import axios from 'axios';
import jwt from 'jwt-simple';
import { isBefore } from 'date-fns';
import get from 'lodash/get';

import { AUTHENTICATION_API_URL } from 'config/env';
import { getJson } from 'lib/localStore';
import { throwWrappedAxiosError } from 'lib/errors';
import { AUTH_TOKEN_KEY, TOKEN_CHECK_INTERVAL } from 'config/constants';

interface CreateTokenArgs {
  bookingId: string;
  bookingReference: string;
  email: string;
  lastName: string;
}

export async function createToken({ bookingId, bookingReference, email, lastName }: CreateTokenArgs) {
  const response = await axios({
    method: 'post',
    url: `${AUTHENTICATION_API_URL}/tokens`,
    data: {
      strategy: 'booking_details',
      application: 'self_service',
      booking_id: bookingId,
      booking_reference: bookingReference,
      last_name: lastName,
      email,
    },
    withCredentials: true,
  }).catch(throwWrappedAxiosError);

  return response.data.access_token;
}

export function getGatekeeperTokenForBooking(bookingId: string) {
  const token = getJson(AUTH_TOKEN_KEY);
  let decodedToken;

  if (token) {
    try {
      decodedToken = jwt.decode(token, '', true);
    } catch (e) {
      return null;
    }

    if (isExpiredGatekeeperToken(decodedToken)) {
      return null;
    }

    if (get(decodedToken, 'data.booking_ids', []).includes(bookingId)) {
      return token;
    }
  }
  return null;
}

export function isExpiredGatekeeperToken({ exp }: { exp: number }) {
  const expiryDate = new Date(exp * 1000 - TOKEN_CHECK_INTERVAL);
  return isBefore(expiryDate, Date.now());
}
